var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94501 3.26974L3.78751 9.78724C3.55501 10.0347 3.33001 10.5222 3.28501 10.8597L3.00751 13.2897C2.91001 14.1672 3.54001 14.7672 4.41001 14.6172L6.82501 14.2047C7.16251 14.1447 7.63501 13.8972 7.86751 13.6422L14.025 7.12474C15.09 5.99974 15.57 4.71724 13.9125 3.14974C12.2625 1.59724 11.01 2.14474 9.94501 3.26974Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91748 4.35742C9.23998 6.42742 10.92 8.00992 13.005 8.21992",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17.0698H15.75",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.f39b434d619d8813e4ec5e74baf364f8.svg";
export { ForwardRef as ReactComponent };